<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.white.py-4
        v-row(no-gutters)
          v-col.ma-0.pa-0
            h6.mb-0.basic800--text {{ $t('webhook_settings') }}
      v-divider.pt-0.mt-0
      v-card-text.pa-0
        v-form(ref="form")
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          v-card.pa-4(v-else-if="!isFetching")
            v-container.pa-0
              v-row(v-for="(event, key) in events" v-bind:key="event.key")
                 v-container.py-0
                  v-layout
                    p.px-1.s1.basic1000-text.mb-0 {{ $t('trigger_when') }} {{ event.description }}
                    v-spacer
                    y-switch.ma-0.pa-0(v-model='event.enabled')
                  v-layout.pt-0.pb-0(no-gutters align="center")
                      p.mb-2.px-1.mt-2.label.basic600--text.text-uppercase.mt-2 {{ $t('webhook_url') }}
                  v-layout.pt-0.pb-10(no-gutters align="center")
                    v-col.px-1.grow
                      v-text-field(solo flat background-color="basic200"    height="40" v-model='event.url' label="Webhook URL"
                                  placeholder="eg: https://www.zapier.com/abcd123" outlined dense persistent-hint
                                  :disabled="!event.enabled" hide-details)
                    v-col.px-1.shrink
                      v-btn.button-AA-medium.white--text.primary( depressed :disabled="!event.enabled" @click="testWebhook(key, event.url)") {{ $t('test') }}
      v-divider
      v-card-actions
        v-spacer
        v-btn.button-AA-tiny(color='primary400', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.button-AA-medium.mr-2.white--text(color='info500' depressed height=32 :loading="isLoading" @click='clickSave')
          | {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'UpdateWebhook',
  props: ['open', 'company'],
  data: () => ({
    fullscreen: true,
    isFetching: true,
    apiKey: null,
    events: null,
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
  },
  created () {
    this.fetchSettings()
  },
  methods: {
     ...mapActions([
      'showMessage'
    ]),
    fetchSettings () {
      this.$axios.get(`/webhooks/${this.company.slug}`)
      .then(response => {
        this.apiKey = response.data.api_key
        const eventObj = response.data.events
        this.events = this.removeConnectWebhook(eventObj)
        this.isFetching = false
      })
      .catch(() => {
        // Create webhook setting if not exist
        this.$axios.post('/webhooks', {company: this.company.id}).then((response) => {
          this.apiKey = response.data.api_key
          const eventObj = response.data.events
          this.events = this.removeConnectWebhook(eventObj)
          this.isFetching = false
        }).catch(() => {})
      })
    },
    testWebhook (event, url) {
      const data = {
        api_key: this.apiKey,
        event: event,
        url: url
      }
      this.$axios.post(`/webhooks/${this.company.slug}/test`, data)
      .then(() => {
      }).catch(() => {})
    },
    clickSave () {
      this.isLoading = true
      this.$axios.patch(`/webhooks/${this.company.slug}`, {events: this.events})
      .catch(() => {})
      .finally(()=>{
        this.isLoading = false
        this.showModal = false
      })
      return
    },
    removeConnectWebhook (obj) {
      delete obj.ConnectCustomerCreated
      delete obj.ConnectTicketCreated
      delete obj.ConnectTicketSolved
      return obj
    }
  }
}
</script>

<style scoped>
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "webhook_settings": "Webhook Settings",
    "trigger_when": "Trigger when",
    "webhook_url": "Webhook URL"
  },
  "id": {
    "webhook_settings": "Peraturan Webhook",
    "trigger_when": "Aktifkan ketika",
    "webhook_url": "Webhook URL"
  }
}
</i18n>
